import { Checkbox, Fieldset, ValidationMessage } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { LeftPaddedContent } from '../../common/styledComponents';
import { TermostatstyringRadio } from '../../common/termostatstyringRadio';
import { useOppvarmingFormContext } from '../../../utils';
import { useCommonValidation } from '../../../hooks/useCommonValidation';

export const Fordelingssystem = () => {
  const { register, watch, formState } = useOppvarmingFormContext();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming.common' });
  const { validateVarmefordeling } = useCommonValidation();

  const gulvvarmeSelected = watch(`olje.value.kjel.value.gulvvarme.selected`);
  const radiatorSelected = watch(`olje.value.kjel.value.radiator.selected`);

  const errors = formState.errors?.olje?.value?.kjel?.value;

  // Radiator and gulvvarme is validated as a group and share the exact same validation and error message.
  // We only display radiator error message.
  const fordelingssystemSelectionError = errors?.radiator?.selected;

  return (
    <Fieldset>
      <Fieldset.Legend>{t('kjel.fordelingssystem.label')}</Fieldset.Legend>
      <Checkbox
        aria-invalid={!!errors?.gulvvarme?.selected}
        label={t('kjel.fordelingssystem.gulvvarme.label')}
        {...register(`olje.value.kjel.value.gulvvarme.selected`, {
          validate: (_, formValues) => validateVarmefordeling(formValues.olje?.value?.kjel?.value),
          deps: [`olje.value.kjel.value.radiator.selected`],
          shouldUnregister: true
        })}
      />
      {gulvvarmeSelected && (
        <LeftPaddedContent>
          <TermostatstyringRadio labelHidden name="olje.value.kjel.value.gulvvarme.value.termostatstyring" />
        </LeftPaddedContent>
      )}

      <Checkbox
        aria-invalid={!!errors?.radiator?.selected}
        label={t('kjel.fordelingssystem.radiator.label')}
        {...register(`olje.value.kjel.value.radiator.selected`, {
          validate: (_, formValues) => validateVarmefordeling(formValues.olje?.value?.kjel?.value),
          deps: [`olje.value.kjel.value.gulvvarme.selected`],
          shouldUnregister: true
        })}
      />
      {radiatorSelected && (
        <LeftPaddedContent>
          <TermostatstyringRadio labelHidden name="olje.value.kjel.value.radiator.value.termostatstyring" />
        </LeftPaddedContent>
      )}

      {fordelingssystemSelectionError && (
        <ValidationMessage>{fordelingssystemSelectionError.message}</ValidationMessage>
      )}
    </Fieldset>
  );
};
